// extracted by mini-css-extract-plugin
module.exports = {"root":"BtnOpenForm_root__1F8xH"};